<template>
  <b-modal
    id="modal-prevent-closing"
    ref="modal"
    v-model="showModal"
    centered
    size="lg"
  >
    <template #modal-header>
      <div class="d-flex justify-content-between w-100">
        <p>{{ question.question }}</p>
        <span class="cursor-pointer h5" @click="showModal = false">&times</span>
      </div>
    </template>
    <div class="d-flex justify-content-between flex-wrap mb-2">
      <b-form
        class="d-flex align-items-center flex-sm-nowrap flex-wrap"
        @submit.prevent="onSearch"
      >
        <b-form-input v-model="search" />
        <b-button variant="primary" class="ml-sm-1 my-0 my-1" type="submit">
          جستجو
        </b-button>
      </b-form>
    </div>
    <data-table :fields="fields" :items="answers" :loading="loading">
      <template #id="{ data }">{{ data.item.id }}</template>
      <template #fullName="{ data }">
        <b-avatar
          size="32"
          :src="data.item.user.avatar"
          :variant="`light-primary`"
        />
        <span class="mx-2">
          {{ data.item.user.first_name + " " + data.item.user.last_name }}
        </span>
      </template>
      <template #answer="{ data }">
        <div>
          <template v-if="data.item.question.type == 2">
            <p v-html="data.item.response"></p>
          </template>
          <template v-else>
            <p>
              {{
                data.item.question.items.find(
                  (item) => item.key == data.item.response
                ).value
              }}
            </p>
          </template>
        </div>
      </template>
    </data-table>
    <div
      class="w-100 d-flex flex-wrap align-items-center justify-content-center"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        size="md"
        class="my-2 d-flex justify-content-center"
      ></b-pagination>
    </div>
    <template #modal-footer>
      <div class="w-100">
        <template v-if="question.type == 2">
          <p class="mr-3">جواب صحیح :</p>

          <p v-html="question.response"></p>
        </template>
        <template v-else>
          <p class="mr-3">جواب صحیح :</p>

          <p>
            {{ question.items.find((item) => item.is_correct == "1").value }}
          </p>
          <p v-if="question.response" class="mr-3">توضیحات :</p>
          <p v-if="question.response" v-html="question.response"></p>
        </template>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BAvatar,
  BBadge,
  BForm,
  BInputGroup,
  BFormInput,
  BButton,
  BPagination,
} from "bootstrap-vue";
import DataTable from "@core/components/data-table/DataTable.vue";
import qs from "qs";
export default {
  components: {
    BModal,
    BAvatar,
    BBadge,
    DataTable,
    BForm,
    BInputGroup,
    BButton,
    BPagination,
    BFormInput,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    question: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      fields: [
        { key: "id", label: "شناسه" },
        { key: "fullName", label: "" },
        { key: "answer", label: "جواب ارسالی" },
      ],
      search: "",
      currentPage: 1,
      pagination: {},
      answers: [],
      loading: false,
      query: {},
    };
  },
  methods: {
    async onSearch() {
      if (this.search) {
        this.query.key = this.search;
      }
      this.query = { ...this.query };
    },
    async getAnswers() {
      this.loading = true;
      try {
        let params = {
          per_page: 8,
          filters: {
            exercise_id: this.$route.params.id,
            session_id: this.$route.query.session_id,
            course_id: this.$route.query.course_id,
            question_id: this.question.id,
          },
          ...this.query,
          includes: ["user", "question"],
        };
        const { data } = await this.$http.get("/panel/answers", {
          params: params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.answers = data.data.answers;
        this.pagination = data.data.meta.pagination;
      } catch (err) {}
      this.loading = false;
    },
  },
  watch: {
    query: {
      handler(val) {
        this.getAnswers();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      if (!this.query.page) {
        this.query.page = val;
      } else if (val != this.query.page) {
        this.query.page = val;
      }
      this.query = { ...this.query };
    },
    search(val) {
      if (!val && this.query.key) {
        delete this.query.key;
        this.query = { ...this.query };
      }
    },
    visible: {
      handler(newVal) {
        if (newVal) {
          this.search = "";
          this.query.key = "";
          this.query.page = "";
          this.getAnswers();
        }
      },
      immediate: true,
    },
  },
  computed: {
    showModal: {
      set(newVal) {
        this.$emit("input", newVal);
      },
      get() {
        return this.visible;
      },
    },
  },
};
</script>

<style></style>
